<template>
    <div id="sub-content" class="s-inner">
        <h3>공매공고</h3>
        <div class="sub-board-top mt100">
            <div class="page-total">
                <p>전체 <span class="num">{{ state.total }}</span>건</p>
            </div>
            <div class="sub-sch-wrap">
                <div class="select-box">
                    <select v-model="state.searchType">
                        <option value="1">제목</option>
                        <option value="2">내용</option>
                    </select>
                </div>
                <input type="text" placeholder="검색어를 입력하세요" v-model="state.searchKeyword" @keyup.enter="eventHandler.onSearchClick">
                <button title="검색" class="sch-btn" @click="eventHandler.onSearchClick">
                    <span class="text_hidden">검색</span>
                </button>
            </div>
        </div>
        <div class="sub-board-wrap sub-faq-wrap board-scroll-wrap">
        <table>
            <thead>
                <tr>
                    <th scope="col" class="th-number">번호</th>
                    <th scope="col" class="th-division">구분</th>
                    <th scope="col" class="th-title">제목</th>
                    <th scope="col" class="th-date">등록일</th>
                    <th scope="col" class="th-hits">조회수</th>
                    <th scope="col" class="th-hits">첨부</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="Items in state.boardItems" v-bind:key="Items">
                    <td class="td-number">{{ Items.Sort }}</td>
                    <td class="td-division">
                        <span v-if="Items.CodeVal === 'PEOPLE002'" class="cate case4">진행</span>
                        <span v-else-if="Items.CodeVal === 'PEOPLE003'" class="cate case3">공매진행</span>
                        <span v-else-if="Items.CodeVal === 'PEOPLE004'" class="cate case1">수의계약</span>
                        <span v-else-if="Items.CodeVal === 'PEOPLE005'" class="cate case5">중지</span>
                        <span v-else-if="Items.CodeVal === 'PEOPLE006'" class="cate case6">취소</span>
                        <span v-else-if="Items.CodeVal === 'PEOPLE007'" class="cate case2">완료</span>
                    </td>
                    <td class="td-subject" @click="eventHandler.dataTable.onRowClick(Items)">
                        <a href='javascript:void(0)'>{{ Items.Title }}</a>
                    </td>
                    <td class="tc">{{ Items.CreateDate }}</td>
                    <td class="tc">{{ Items.Hit }}</td>
                    <td class="tc" :style="{'text-align':'center', 'width' : '150px'}">
                        <i v-if="Items.FileCnt > 0" class="fa fa-save"><span class="sr-only"></span></i>
                    </td>
                </tr>
            </tbody>
        </table>
        </div>

        
        <!--페이징 처리 시작-->
        <div class="paging-box">
            <a href="#" title="처음으로" class="first_btn" @click="methods.onPageChange(1, 'Y')"><span class="text_hidden">처음으로</span></a>
            <a href="#" title="이전으로" :disabled="state.CurPage === 1" @click="methods.onPageChange(state.CurPage -1, 'N')" class="prev_btn"><span class="text_hidden">이전으로</span></a>
            
            <ul>
                <li v-for="(paging) in state.pages" v-bind:key="paging"  :class="paging === state.CurPage ? 'on' : ''">
                    <a href="#" @click="methods.onPageChange(paging, 'Y')">{{ paging }}</a>
                </li>
            </ul>

            <a href="#" title="다음으로" :disabled="state.CurPage >= state.total - 1" @click="methods.onPageChange(state.CurPage +1, 'N')" class="next_btn"><span class="text_hidden">다음으로</span></a>
            <a href="#" title="맨끝으로" class="end_btn" @click="methods.onPageChange(state.totalPage, 'Y')"><span class="text_hidden">맨끝으로</span></a>
        </div>
        <!--페이징 처리 끝-->

    </div>
</template>
<script>
import { reactive } from '@vue/reactivity';
import { krtBoardCommon } from '@/modules/krt-board-common.js';
import { onMounted } from '@vue/runtime-core';
import { useStore } from 'vuex';
import { useRoute } from "vue-router";
import router from '@/router'
export default {
    setup() {
        //라우터
        const vrt = useRoute();
        // 스토어   
        const store = useStore();
        
        // state (변수)
        const state = reactive({

            // 시스템코드
            systemCode: 'ADM',

            // 게시판 카테고리
            boardCategory: 'KRTCM006',

            // 게시판 목록
            boardItems: [],

            // 검색유형 (1: 제목, 2: 내용)
            searchType: '1',

            // 검색어
            searchKeyword: !!vrt.query.Keyword ? vrt.query.Keyword : null,

            //현재페이지
            CurPage: 1,
            //전체페이지 수
            total: 0,
            //페이징처리
            pages : [],
            startPage : 1,
            EndPage : 10,
            totalPage: 0,
        });

        const eventHandler = {

            /**
             * 검색버튼 클릭 이벤트 처리
             */
            onSearchClick: () => {
                vrt.query.num = null;
                vrt.query.Keyword = state.searchKeyword;
                state.CurPage = 1;
                history.pushState(null, null, `?num=1&Keyword=${state.searchKeyword}`);

                methods.getBoardItems();
            },

            dataTable: {
                /**
                 * # List Row Clicked
                 * @param event e 
                 */
                onRowClick: (e) => {

                    event.preventDefault();

                    var q = vrt.query;
                    q["Seq"] = e.Seq;
                    q["num"] = !!vrt.query.num ? vrt.query.num : 1;
                    q["Keyword"] = !!vrt.query.Keyword ? vrt.query.Keyword : null;
                    
                    router.push({ name: 'ShortNoticeDetail', query: q });
                }
            }
        }

        const methods = {

            /**
             * 게시판 목록 가져오기
             */
            getBoardItems: () => {

                krtBoardCommon.getKRTBoardContentList2(
                    state.systemCode,
                    state.boardCategory,
                    state.searchType,
                    state.searchKeyword,
                    state.CurPage
                ).then(boardItems => {

                    state.boardItems = boardItems.Table.rows;
                    state.total = boardItems.Table1.rows[0].TotalCnt;

                    state.pages= []; // 초기화
                    state.totalPage = Math.ceil(state.total / 15 );
                    let PageGroup = Math.ceil(state.CurPage / state.EndPage);
                    
                    let EndPage = PageGroup * state.EndPage;
                    if(EndPage > state.totalPage){
                        EndPage = state.totalPage
                    }

                    state.startPage = (PageGroup - 1) * state.EndPage + 1;

                    let idx = 0;
                    for(let i=state.startPage; i<=EndPage; i++){
                        state.pages[idx] = i;
                        idx++;
                    }
                    
                }).finally(() => {

                });
            },

            onPageChange (val, startEnd) {
                if(startEnd === "N"){
                    if (val <= 0 && startEnd==="N") {
                        alert('첫 페이지입니다.');
                        return;
                    }
                    if (val > state.totalPage && startEnd==="N") {
                        alert('마지막 페이지입니다.');
                        return;
                    }
                }
                
                state.CurPage = val;
                history.pushState(null, null, `?num=${val}&Keyword=${state.searchKeyword}`);

                this.getBoardItems();
            },
        }

        onMounted(() => {

            if(!!vrt.query.num) state.CurPage = vrt.query.num * 1;
            if(vrt.query.Keyword == 'null') state.searchKeyword = null;

            // IR 자료 목록 가져오기
            methods.getBoardItems();
        });

        return {

            state,
            eventHandler,
            methods,
            store,
        }
    },
}
</script>
